<template>
    <div class="cbd-plate cbd-footer-menu" :data-spm="spmCCode">
        <section class="cooperation">
            <a class="item" v-for="(item, index) in textLink" :key="index" :href="item.url" :data-spm-data="item.dataSpmData">{{item.title}} </a>
        </section>
        <footer class="copyright">
            <p>{{copyright}}</p>
            <p class="company-font">{{declare}}</p>
        </footer>
    </div>
</template>
<script>
    const locationWithoutParams = encodeURIComponent(location.origin + location.pathname)
    const feedbackHrefMap = {
        'prod':'//m.sohu.com/feedback?page=function&fburl='+locationWithoutParams,
        'test':'//test-m.sohu.com/feedback?page=function&fburl='+locationWithoutParams,
        'pre':'//m.sohu.com/feedback?page=function&fburl='+locationWithoutParams,
    }
    const feedbackHref = feedbackHrefMap[window.deployEnv || 'prod']
    export default {
        name: "FooterMenu",
        props: ['serverTime'],
        data() {
            return {
                textLink:[
                    {
                        title:'意见反馈',
                        url: feedbackHref,
                        dataSpmData:"fb"
                    },
                    {
                        title:'合作',
                        url:'https://m.sohu.com/cooperation',
                    },
                    {
                        title:'隐私政策',
                        url:'https://m.sohu.com/xchannel/TURBd01EQXdNekky'
                    }
                ],
                declare:'搜狐公司 版权所有',
                spmCCode:'footer',
                year: 2024
            }
        },
        created() {
            this.year = new Date(this.serverTime).getFullYear()
        },
        computed:{
            copyright(){
                return `Copyright © ${this.year} Sohu All Rights Reserved`
            }
        }
    };
    </script>

    <style scoped lang="less">
    // 底部版权
    .cbd-footer-menu {
        background-color: #f5f5f5;
        padding-top: 60px;
        padding-bottom: 40px;
        border-bottom: none;
        &.article {
            background-color: #f2f2f2;
        }
        .cooperation {
            display: flex;
            justify-content: center;
            .item {
                position: relative;
                padding: 0 16px;
                font-size: 30px; /*px*/
                line-height: 30px; /*px*/
                color: #656565;
                text-decoration: none;
                &:after {
                    content: "·";
                    position: absolute;
                    right: -8px;
                    top: 0;
                    color: #d7d7d7;
                }
                &:last-child {
                    &:after {
                    content: "";
                    }
                }
            }
        }
        .copyright {
            padding-top: 40px;
            text-align: center;
            color: #656565;
            a {
                color: #a4a4a4;
                font-size: 24px;
                display: inherit;
                margin-top: 20px;
            }
            p {
            margin: 20px 0 0 0;
            font-size: 24px; /*px*/
            line-height: 24px; /*px*/
            color: #a4a4a4;
            }
        }
    }
</style>